const SET_AUTH_USER = 'magblocks/SET_AUTH_USER';
const SET_AUTH_LOADING = 'magblocks/SET_AUTH_LOADING';

const initialState = {
    user: null,
    isLoggedIn: false,
    authLoading: true
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_AUTH_USER:
        return {...state, user: action.user, isLoggedIn: !!action.user};
    case SET_AUTH_LOADING:
        return {...state, authLoading: action.loading};
    default:
        return state;
    }
};

const setAuthUser = user => ({type: SET_AUTH_USER, user});
const setAuthLoading = loading => ({type: SET_AUTH_LOADING, loading});

export {
    reducer as default,
    initialState as magblocksAuthInitialState,
    setAuthUser,
    setAuthLoading
};
